import { useFragment_experimental } from '@apollo/client';
import { PROJECT_PAGE_FRAGMENT } from '../gql/projectPageFragment';
import { useEffect, useState } from 'react';
import apiClient from 'helpers/api-client';

const useCacheGetProjectPage = ({ pageId, pageDatabaseId }) => {
  const [captureOutputRequest, setCaptureOutputRequest] = useState(null);
  // A query to get a single project page doesn't exist yet, so we're using a fragment instead since we already grab the page in the project pages query
  const { complete, data } = useFragment_experimental({
    fragment: PROJECT_PAGE_FRAGMENT,
    fragmentName: 'ProjectPageFragment',
    from: {
      __typename: 'ProjectPage',
      id: pageId,
    },
  });

  useEffect(() => {
    apiClient
      .get(`/pages/${pageDatabaseId}`)
      .then((response) => {
        setCaptureOutputRequest(response.capture_output_request);
      })
      .catch((error) => {
        console.error('Error fetching capture output request', error);
      });
  }, [pageDatabaseId]);

  return {
    complete,
    page: { ...data, captureOutputRequest },
  };
};

export default useCacheGetProjectPage;
